import { createRouter, createWebHistory } from 'vue-router'

import { generateRoutes } from '@/extensions/langRouter'

const routes = [
  {
    path: '',
    paths: { en: '', fr: '' },
    name: 'home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/a-propos',
    paths: { en: '/about', fr: '/a-propos' },
    name: 'about',
    component: () => import('@/views/About.vue'),
  },
  {
    path: '/a-propos/conseil-dadministration',
    paths: { en: '/about/board-of-directors', fr: '/a-propos/conseil-dadministration' },
    name: 'board',
    component: () => import('@/views/DirectorsBoard.vue'),
  },
  {
    path: '/produits/:slug?',
    paths: { en: '/products/:slug?', fr: '/produits/:slug?' },
    name: 'product.index',
    component: () => import('@/views/Product/Index.vue'),
    props: true,
    meta: { noScroll: true },
  },
  {
    path: '/developpement-durable',
    paths: { en: '/sustainability', fr: '/developpement-durable' },
    name: 'sustainability',
    component: () => import('@/views/Sustainability.vue'),
  },
  {
    path: '/carrieres',
    paths: { en: '/careers', fr: '/carrieres' },
    name: 'careers',
    component: () => import('@/views/Careers.vue'),
  },
  {
    path: '/contact',
    paths: { en: '/contact', fr: '/contact' },
    name: 'contact',
    component: () => import('@/views/Contact.vue'),
  },
  {
    path: '/accessibilite',
    paths: { en: '/accessibility', fr: '/accessibilite' },
    name: 'accessibility',
    component: () => import('@/views/Policy.vue'),
  },
  {
    path: '/confidentialite',
    paths: { en: '/privacy', fr: '/confidentialite' },
    name: 'privacy',
    component: () => import('@/views/Policy.vue'),
  },
  {
    path: '/responsabilite',
    paths: { en: '/disclaimer', fr: '/responsabilite' },
    name: 'disclaimer',
    component: () => import('@/views/Policy.vue'),
  },
  {
    path: '/modalites-sms',
    paths: { en: '/sms-terms', fr: '/modalites-sms' },
    name: 'sms',
    component: () => import('@/views/Policy.vue'),
  },
  {
    path: '/blogue',
    paths: { en: '/blog', fr: '/blogue' },
    name: 'post.index',
    component: () => import('@/views/Post/Index.vue'),
  },
  {
    path: '/blogue/:slug',
    paths: { en: '/blog/:slug', fr: '/blogue/:slug' },
    name: 'post.show',
    component: () => import('@/views/Post/Show.vue'),
    props: true,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'catch-all',
    component: () => import('@/views/NotFound.vue'),
  },
]

const localizedRoutes = generateRoutes(routes, 'fr', ['en'])

export default createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: '-active',
  linkExactActiveClass: '-exact-active',
  routes: localizedRoutes,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      const target = {
        el: to.hash,
        behavior: 'smooth',
        top: window.innerWidth > 1024 ? 84 : 64,
      }

      return to.name === from.name
        ? target
        : new Promise((resolve) => setTimeout(() => resolve(target), 1500))
    }

    if (savedPosition) {
      return savedPosition
    }

    if (to.name === from.name) {
      return Object.keys(to.query).length || Object.keys(from.query).length
        ? {}
        : { top: 0, behavior: 'smooth' }
    }

    return new Promise((resolve) => setTimeout(() => resolve({ top: 0 }), 300))
  },
})
